const normalizeSearchToken = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[_.-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const collectSearchSegments = (value, segments) => {
  if (value === null || value === undefined) {
    return;
  }

  if (value instanceof Date) {
    segments.push(value.toISOString());
    return;
  }

  const valueType = typeof value;

  if (valueType === "string" || valueType === "number" || valueType === "boolean") {
    segments.push(String(value));
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectSearchSegments(item, segments));
    return;
  }

  if (valueType === "object") {
    Object.entries(value).forEach(([key, nestedValue]) => {
      segments.push(key);
      collectSearchSegments(nestedValue, segments);
    });
  }
};

export const buildTableSearchText = (row, headers = [], extraSegments = []) => {
  const segments = [...headers, ...extraSegments];

  collectSearchSegments(row, segments);

  return normalizeSearchToken(segments.join(" "));
};

export const filterRowsByTableSearch = ({
  rows = [],
  query = "",
  headers = [],
  getExtraSearchText,
}) => {
  const normalizedQuery = normalizeSearchToken(query);

  if (!normalizedQuery) {
    return rows;
  }

  const tokens = normalizedQuery.split(" ").filter(Boolean);

  return rows.filter((row) => {
    const extraText = typeof getExtraSearchText === "function" ? getExtraSearchText(row) : "";
    const searchableText = buildTableSearchText(row, headers, extraText ? [extraText] : []);

    return tokens.every((token) => searchableText.includes(token));
  });
};
